import type { AuthModuleData, ShareAuthCheckData, AuthPageParams, ShareOwnerResponse } from '../types';

export interface AuthService {
    shareAccessCheck(data: ShareAuthCheckData): Promise<boolean>;
    getOwnerInfo(data: ShareAuthCheckData): Promise<ShareOwnerResponse>;
    updateAuthState(data: AuthModuleData): void;
    setPageParams(params: AuthPageParams): void;
    get pageParams(): AuthPageParams;
    get authModelData(): AuthModuleData;
    backToHome(): void;
    handleLogin(): Promise<boolean>;
    handleAccessError(): void;
}

export const AuthService = Symbol('AuthService');
